import whichEnv from '@ally/which-env'

// Forgot Password
const desktopForgotPasswordPathname =
  '/auto/online-services/access/forgot-password-user-identification.html'

// Forgot Username (mobile and desktop use the same URL)
const forgotUsernamePathname =
  '/auto/online-services/access/forgot-user-name.html'

// Enrollment
const desktopEnrollmentPathname =
  '/auto/online-services/access/forgot-user-name.html'
const mobileEnrollmentPathname = '/auto/index.html?pageName=enroll-online'

const getDesktopBaseUrl = (): string => {
  return whichEnv(window.location.href).pick({
    local: `https://www-cit2.ally.com`,
    dev: `https://www-cit2.ally.com`,
    qa1: 'https://www-uat2.ally.com',
    qa2: 'https://www-uat2.ally.com',
    qa3: 'https://www-uat2.ally.com',
    cap: 'https://www-cap.int.ally.com',
    psp: 'https://www-prodsupt.ally.com',
    prod: 'https://www.ally.com',
  })
}

const getMobileBaseUrl = (): string => {
  return whichEnv(window.location.href).pick({
    local: `https://m-cit2.ally.com`,
    dev: `https://m-cit2.ally.com`,
    qa1: 'https://m-uat2.ally.com',
    qa2: 'https://m-uat2.ally.com',
    qa3: 'https://m-uat2.ally.com',
    cap: 'https://m-cap.int.ally.com',
    psp: 'https://m-prodsupt.ally.com',
    prod: 'https://m.ally.com',
  })
}

const getAAOSForgotPasswordUrl = (): string => {
  return `${getDesktopBaseUrl()}${desktopForgotPasswordPathname}`
}

const getAAOSForgotUsernameUrl = (): string => {
  // Forgot Username always uses the desktop URL, there is no mobile variant
  return `${getDesktopBaseUrl()}${forgotUsernamePathname}`
}

const getAAOSEnrollmentUrl = (isMobile: boolean): string => {
  const baseUrl = isMobile ? getMobileBaseUrl() : getDesktopBaseUrl()
  const pathname = isMobile
    ? mobileEnrollmentPathname
    : desktopEnrollmentPathname

  return `${baseUrl}${pathname}`
}

export {
  getAAOSForgotPasswordUrl,
  getAAOSForgotUsernameUrl,
  getAAOSEnrollmentUrl,
}
